import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { apiFetch } from "@/lib/api";

export function QuickBooksTimeOAuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Finishing QuickBooks Time sign-in…");

  useEffect(() => {
    const code = searchParams.get("code")?.trim() ?? "";
    const state = searchParams.get("state")?.trim() ?? "";
    const oauthError = searchParams.get("error")?.trim() ?? "";
    const oauthErrorDescription = searchParams.get("error_description")?.trim() ?? "";

    if (oauthError !== "") {
      setMessage(oauthErrorDescription !== "" ? oauthErrorDescription : oauthError);
      return;
    }
    if (code === "" || state === "") {
      setMessage("QuickBooks Time did not return a complete sign-in response.");
      return;
    }

    let cancelled = false;
    void apiFetch<{ returnTo: string; uiOrigin: string }>(
      "/api/manufacturing/reporting/quickbooks-time/oauth/complete",
      {
        method: "POST",
        body: { code, state },
      },
    )
      .then((result) => {
        if (cancelled) {
          return;
        }
        const destination = new URL(result.returnTo, result.uiOrigin);
        destination.searchParams.set("quickbooksTime", "connected");
        void navigate(`${destination.pathname}${destination.search}${destination.hash}`, { replace: true });
      })
      .catch((error: unknown) => {
        if (cancelled) {
          return;
        }
        const text = error instanceof Error ? error.message : "QuickBooks Time sign-in failed.";
        setMessage(text);
      });

    return () => {
      cancelled = true;
    };
  }, [navigate, searchParams]);

  return (
    <div className="mx-auto flex min-h-[40vh] max-w-lg flex-col items-center justify-center px-6 text-center">
      <p className="text-sm text-slate-700">{message}</p>
    </div>
  );
}
